export default function getLocalization(stringKey) {
  if (typeof window.espatent_screenReaderText === 'undefined' || typeof window.espatent_screenReaderText[stringKey] === 'undefined') {
    // eslint-disable-next-line no-console
    console.error(`Missing translation for ${stringKey}`);
    return '';
  }
  return window.espatent_screenReaderText[stringKey];
}
